import { UserManager } from 'oidc-client-ts';
import store from '@state/store';
import router from '@router';
import JwtService from './JwtService';
import { StaffApiService } from '@common/ApiService';
const ONELOGIN_CLIENT_ID = process.env.VUE_APP_ONELOGIN_CLIENT_ID;
const ONELOGIN_URL = process.env.VUE_APP_OAUTH_PROVIDER_URL;
const settings = {
    authority: `${ONELOGIN_URL}/oidc/2`,
    client_id: ONELOGIN_CLIENT_ID,
    redirect_uri: `${window.location.origin}/callback`,
    response_type: 'code',
    post_logout_redirect_uri: window.location.origin,
    scope: 'openid',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
};
const mgr = new UserManager(settings);
let isLoggingOut = false;
export const getIsLoggingOut = () => isLoggingOut;
export const redirectToOlLogin = () => {
    mgr.signinRedirect();
};
export const logoutUser = async () => {
    if (isLoggingOut)
        return;
    isLoggingOut = true;
    mgr.stopSilentRenew();
    const idTokenHint = JwtService.getIdToken();
    const origin = window.location.origin;
    const logoutUrl = `${ONELOGIN_URL}/oidc/2/logout?id_token_hint=${idTokenHint}&post_logout_redirect_uri=${origin}`;
    // Call the backend logout endpoint while the token is still valid.
    // This triggers OneLogin's admin logout API (DELETE /api/1/users/{id}/logout)
    // which kills the server-side session and deletes the PA device. Without this,
    // the OIDC browser-side logout alone is intermittently insufficient and OneLogin
    // can silently re-authenticate the user on the post_logout_redirect.
    try {
        await StaffApiService.delete('v1/onelogin/logout');
    }
    catch (error) {
        // non-fatal — proceed with client-side logout regardless
    }
    try {
        await mgr.removeUser();
    }
    catch (error) {
        // non-fatal
    }
    finally {
        store.commit('auth/AUTH_CLEAR');
        window.localStorage.removeItem('DEVICE_ID');
        if (idTokenHint && idTokenHint.length > 50) {
            window.location.assign(logoutUrl);
        }
        else {
            redirectToOlLogin();
        }
    }
};
export const renewToken = async () => {
    if (isLoggingOut)
        throw new Error('Token renewal skipped: logout in progress');
    mgr.clearStaleState();
    const token = await mgr
        .signinSilent()
        .then((user) => {
        store.dispatch('auth/processOneLoginResponse', user);
        return user;
    })
        .catch((error) => {
        logoutUser();
        throw error;
    });
    return token;
};
export async function processLoginResponse() {
    try {
        // The callback URI is also used by silent renewal in an iframe. OIDC's
        // stored request type decides whether to notify the parent or sign in here.
        const user = await mgr.signinCallback();
        if (!user)
            return;
        store.dispatch('auth/loggingInStatus', 'processing');
        await mgr.clearStaleState();
        await store.dispatch('auth/processOneLoginResponse', user);
        await store.dispatch('auth/createDevice');
        store.dispatch('auth/endShift');
        store.dispatch('auth/loggingInStatus', 'complete');
        store.dispatch('auth/queryAccount');
        store.dispatch('global/getFeatureFlags');
        await router.push({ name: 'landing-page' });
    }
    catch (error) {
        redirectToOlLogin();
        store.commit('auth/AUTH_ERROR', error);
    }
}
if (window.location.pathname === '/callback') {
    void processLoginResponse();
}
export default {
    redirectToOlLogin,
    logoutUser,
    renewToken,
};
